// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="help-approved-lenders-automate-and-navigate-the-va-home-loan-process.">Help approved lenders automate and navigate the VA home loan process.</h2>
      <p>Our Loan Guaranty (LGY) APIs assist with processing and guaranteeing VA home loans. <Link to="/release-notes/loanGuaranty">Review the latest release notes</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
